<template>
	<div :id="blok._uid">
		<nuxt-link
			:to="formatSbUrl(blok.link)"
			class="grid grid-cols-5 grid-rows-1 content-start items-center gap-2 py-xs hover:underline lg:grid-cols-12"
		>
			<v-icon :icon="icon" class="col-start-1 row-start-1 text-2xl" />

			<p class="col-span-full col-start-2 row-start-1">
				{{ blok.link_text }}
			</p>
		</nuxt-link>
	</div>
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

import formatSbUrl from "@pkg/shared/utils/format-sb-url";

const properties = defineProps<{
	blok: Extract<BlokComponent, {component: "sb-social-link"}>;
}>();

const icon = computed(() => properties.blok.icon);
</script>
